"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _find = _interopRequireDefault(require("lodash/find"));
var _Vector = _interopRequireDefault(require("ol/layer/Vector.js"));
var _Feature = _interopRequireDefault(require("ol/Feature.js"));
var _Point = _interopRequireDefault(require("ol/geom/Point.js"));
var _Projection = _interopRequireDefault(require("ol/proj/Projection.js"));
var _proj = require("ol/proj");
var _Vector2 = _interopRequireDefault(require("ol/source/Vector.js"));
var _Style = _interopRequireDefault(require("ol/style/Style.js"));
var _Icon = _interopRequireDefault(require("ol/style/Icon.js"));
var _Text = _interopRequireDefault(require("ol/style/Text.js"));
var _Fill = _interopRequireDefault(require("ol/style/Fill.js"));
var _Stroke = _interopRequireDefault(require("ol/style/Stroke.js"));
var _GeoJSON = _interopRequireDefault(require("ol/format/GeoJSON.js"));
var _map = require("../map");
var _parkingLot = _interopRequireDefault(require("../../../../assets/icons/parking-lot.png"));
var _keolisParkingLot = _interopRequireDefault(require("../../../../assets/icons/keolis-parking-lot.png"));
var _constants = require("../../../lib/constants");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
// import ol from "openlayers";

// STYLES
var facilityIconStyle = new _Style["default"]({
  image: new _Icon["default"]({
    anchor: [0.5, 1],
    anchorXUnits: 'fraction',
    anchorYUnits: 'fraction',
    opacity: 1,
    src: _parkingLot["default"],
    imgSize: [40, 40]
  }),
  text: new _Text["default"]({
    font: 'bold 11px "Open Sans", "Arial Unicode MS", "sans-serif"',
    placement: 'point',
    fill: new _Fill["default"]({
      color: '#000'
    }),
    stroke: new _Stroke["default"]({
      color: '#fff',
      width: 3
    })
  })
});
var keolisParkingLotIconStyle = new _Style["default"]({
  image: new _Icon["default"]({
    anchor: [0.5, 1],
    anchorXUnits: 'fraction',
    anchorYUnits: 'fraction',
    opacity: 1,
    src: _keolisParkingLot["default"],
    imgSize: [40, 40]
  }),
  text: new _Text["default"]({
    font: 'bold 11px "Open Sans", "Arial Unicode MS", "sans-serif"',
    placement: 'point',
    fill: new _Fill["default"]({
      color: '#000'
    }),
    stroke: new _Stroke["default"]({
      color: '#fff',
      width: 3
    })
  })
});
var useHoverStyle = false;
var handleVisibile = function handleVisibile() {
  if (layer.facilities) {
    return 1;
  }
  return _constants.PARKING_LOT_ZOOM;
};
var layer = new _Vector["default"]({
  visible: true,
  name: "facilities",
  updateWhileAnimating: true,
  updateWhileInteracting: true,
  minZoom: _constants.PARKING_LOT_ZOOM,
  zIndex: _constants.PARKING_LOT_Z_LEVEL,
  style: function style(feature) {
    var operator = feature.get('operator');
    if (operator == 'Keolis Commuter Services') {
      var _feature$getPropertie = feature.getProperties(),
        name = _feature$getPropertie.facility_long_name;
      // keolisParkingLotIconStyle.getText().setText(name);
      return keolisParkingLotIconStyle;
    } else {
      var _feature$getPropertie2 = feature.getProperties(),
        _name = _feature$getPropertie2.facility_long_name;
      // facilityIconStyle.getText().setText(name);
      return facilityIconStyle;
    }
  }
});
_map.map.addLayer(layer);
var facilities = {
  handleUpdate: function handleUpdate(_ref) {
    var facilitiesGeoJson = _ref.facilities,
      hovered = _ref.hovered;
    // if (layers.facilities) {
    //   layer.set('minZoom', 1)
    // } else {
    layer.set('minZoom', _constants.PARKING_LOT_ZOOM);

    //early cutoff for when layer is not visible or unavailable

    if (!facilitiesGeoJson || !facilitiesGeoJson.type) return;
    var facilitiesToRender = facilitiesGeoJson.features;

    // set the features to this layer
    var features = new _GeoJSON["default"]({
      featureProjection: 'EPSG:3857'
    }).readFeatures({
      type: 'FeatureCollection',
      features: facilitiesToRender
    });
    layer.setSource(new _Vector2["default"]({
      features: features
    }));
  },
  getOverlay: function getOverlay(facilityId, facilitiesGeoJson) {
    var _facility$properties;
    var features = facilitiesGeoJson.features;
    var facility = (0, _find["default"])(features, function (feat) {
      return feat.id === facilityId;
    });
    if (!facility) {
      return null;
    }

    // set position
    var coords = facility.geometry.coordinates;
    _map.overlay.setPosition((0, _proj.transform)([coords[0], coords[1]], "EPSG:4326", "EPSG:900913"));
    _map.overlay.setProperties({
      layer: "facilities",
      facilityId: facilityId
    });
    // output rendered content
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: "overlay-content basic p-0"
    }, /*#__PURE__*/_react["default"].createElement("div", {
      style: {
        backgroundColor: '#3776d7',
        color: '#fff',
        borderRadius: '4px 4px 0px 0px'
      },
      className: "text-center p-2"
    }, (facility === null || facility === void 0 ? void 0 : (_facility$properties = facility.properties) === null || _facility$properties === void 0 ? void 0 : _facility$properties.facility_long_name) && /*#__PURE__*/_react["default"].createElement("h4", {
      className: "m-0"
    }, facility.properties.facility_long_name)), /*#__PURE__*/_react["default"].createElement("div", {
      className: "p-3"
    }, Object.keys(facility.properties).map(function (key) {
      return /*#__PURE__*/_react["default"].createElement("span", {
        style: {
          fontSize: 10,
          display: 'block'
        },
        key: key
      }, key, ": ", facility.properties[key]);
    })));
  }
};
var _default = facilities;
exports["default"] = _default;